module.exports = __webpack_public_path__ + "img/member_center_footer431003.baf35257.jpeg";